import type { FilterDefinition, FilterHandler } from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
  type SegmentedFilter,
} from '../types/filters';

export const multiGrowthRateDefinition: FilterDefinition<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  id: FilterId.MULTI_GROWTH_RATE,
  name: 'Growth Rate',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.GROWTH_RATE,
  instances: [],
  isVisible: true,
};

export const multiGrowthRateHandler: FilterHandler<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  isActive(currentFilterState) {
    return currentFilterState.instances.length > 0;
  },
  isDefault(currentFilterState) {
    return currentFilterState.instances.length === 0;
  },
  getEffectiveFilter(currentFilterState) {
    return currentFilterState;
  },
};
